import { render } from "./AppHeader.vue?vue&type=template&id=07a14e2e"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=07a14e2e&lang=css"

import exportComponent from "/Users/ts/Desktop/works/vue3_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__